import {Injectable} from '@angular/core';
import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): any {
    let url =  environment.API_ENDPOINT;
    if (req.headers.get('skip')) {
      url = environment.BACKEND_ENDPOINT;
    }

    const langReq = req.clone({url: ''});
    const apiRequest = req.clone({url: url + req.url});
    if (req.url.includes('assets/i18n')) {
      return next.handle(langReq);
    } else if (/^https?:\/\//.test(req.url)) {
      return next.handle(req);
    } else {
      return next.handle(apiRequest);
    }
  }
}
